module.exports = __webpack_public_path__ + "img/banner.c2d23a97.png";